import MessageInfo from "notifications/message-notifications/message-info/message-info";
import MessageNotificationSchema, {
  MessageNotificationParams,
  MessageNotificationJSON,
} from "notifications/message-notifications/_schemas/message-notification-schema";
import Notification from "notifications/notification";

export default class MessageNotification extends Notification {
  public static create(values: MessageNotificationParams): MessageNotification {
    const parsed = MessageNotificationSchema.validate(values);
    return new MessageNotification(parsed);
  }

  public static fromJSON(value: MessageNotificationJSON): MessageNotification {
    const parsed = MessageNotificationSchema.deserialize(value);
    return new MessageNotification(parsed);
  }

  public readonly messageInfo?: MessageInfo;

  private constructor(values: MessageNotificationParams) {
    super(values);
    this.messageInfo = values.messageInfo ? MessageInfo.create(values.messageInfo) : undefined;
  }

  public toJSON(): MessageNotificationJSON {
    return MessageNotificationSchema.serialize(this);
  }

  public isEqualTo(other: MessageNotification): boolean {
    if (!(other instanceof MessageNotification)) return false;

    return (
      super.isEqualTo(other) &&
      ((this.messageInfo === undefined && other.messageInfo === undefined) ||
        (this.messageInfo !== undefined &&
          other.messageInfo !== undefined &&
          this.messageInfo.isEqualTo(other.messageInfo)))
    );
  }

  public toString(): string {
    return `MessageNotification { id: ${this.id.value}, messageInfo: ${this.messageInfo?.toString() ?? "undefined"} }`;
  }
}
